var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.824 3.13684L14.776 6.08885M1.984 12.9769L1 16.9129L4.93601 15.9289L16.3367 4.52822C16.7056 4.15916 16.9129 3.65868 16.9129 3.13684C16.9129 2.61499 16.7056 2.11451 16.3367 1.74545L16.1674 1.57621C15.7984 1.20726 15.2979 1 14.776 1C14.2542 1 13.7537 1.20726 13.3847 1.57621L1.984 12.9769Z",
    stroke: "#A6A6A6",
    strokeWidth: 1.47619,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.2adc5cd54da7c67e46258841678072b5.svg";
export { ForwardRef as ReactComponent };